import { render, staticRenderFns } from "./AgTable.vue?vue&type=template&id=1c0eb6c8&"
import script from "./AgTable.vue?vue&type=script&lang=js&"
export * from "./AgTable.vue?vue&type=script&lang=js&"
import style0 from "./AgTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports